"use client";

import { Heading } from "@/components/ui/typography";

const rows = [
  { activity: "Selling to US customers", tax: "Typically offshore" },
  { activity: "Consulting a Hong Kong company", tax: "Typically local" },
  { activity: "Running a warehouse in Hong Kong", tax: "Typically local" },
  { activity: "Operating remotely for overseas clients", tax: "Often offshore" },
];

export default function HKSourceTaxTable({ heading = "Hong Kong Source vs Non-Source Income Explained Simply" }: { heading?: string } = {}) {
  return (
    <section className="bg-black py-[60px] flex justify-center px-4">

      <div className="w-full max-w-[1200px] flex flex-col gap-[50px]">

        {/* HEADER */}
        <div className="flex flex-col gap-6">
          <Heading as="h2" variant="section" className="max-w-[548px]">
            {heading}
          </Heading>

          <p className="text-white/70 text-[15px] sm:text-[16px] leading-[24px] font-medium max-w-[700px]">
            Hong Kong determines taxation based on profit source location, not
            company registration location.
          </p>
        </div>

        {/* TABLE */}
        <div className="flex flex-col gap-6">

          {/* HEADER ROW */}
          <div className="flex justify-between md:px-5 px-2">
            <span className="font-cambo text-[20px] sm:text-[24px] text-white">
              Activity
            </span>
            <span className="font-cambo text-[20px] sm:text-[24px] text-white">
              Tax treatment
            </span>
          </div>

          {/* ROWS */}
          <div className=" rounded-[16px] overflow-hidden">

            {rows.map((item, index) => (
              <div
                key={index}
                className="flex justify-between items-center px-2 md:px-5 py-5 border-b border-white/10 last:border-b-0"
              >
                <span className="text-white text-[16px] sm:text-[18px] w-[60%]">
                  {item.activity}
                </span>

                <span className="text-white text-[16px] sm:text-[18px] text-right">
                  {item.tax}
                </span>
              </div>
            ))}

          </div>

          {/* FOOTNOTE */}
          <p className="text-white text-[16px] leading-[24px] font-medium">
            This source test determines tax outcome.
          </p>

          <a
            href="#"
            className="text-[#335cff] text-[16px] font-medium underline"
          >
            ↗ Hong Kong Inland Revenue Department
          </a>

        </div>
      </div>
    </section>
  );
}